/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import hardwareEntityGatewayTemplate from '../hardware-entities/hardware-entities-gateway.tpl.html';
import hardwareEntityDeviceTemplate from '../hardware-entities/hardware-entities-device.tpl.html';

/*@ngInject*/
export default function HardwareEntitiesRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.hardware-entities', {
            url: '/entities',
            module: 'private',
            auth: [types.authority.SYS_ADMIN.value, types.authority.SYS_USER.value],
            redirectTo: 'home.hardware-entities.gateway',
            ncyBreadcrumb: {
                label: '{"icon": "devices", "label": "hardware-entities.entities"}'
            }
        })
        .state('home.hardware-entities.gateway', {
            url: '/gateways',
            module: 'private',
            auth: [types.authority.SYS_ADMIN.value, types.authority.SYS_USER.value],
            views: {
                "content@home": {
                    templateUrl: hardwareEntityGatewayTemplate,
                    controllerAs: 'vm',
                    controller: 'HardwareEntitiesController'
                }
            },
            data: {
                pageTitle: 'gateway.gateways'
            },
            ncyBreadcrumb: {
                label: '{"icon": "router", "label": "gateway.gateways"}'
            }
        })
        .state('home.hardware-entities.device', {
            url: '/devices',
            module: 'private',
            auth: [types.authority.SYS_ADMIN.value, types.authority.SYS_USER.value],
            views: {
                "content@home": {
                    templateUrl: hardwareEntityDeviceTemplate,
                    controllerAs: 'vm',
                    controller: 'HardwareEntitiesController'
                }
            },
            data: {
                pageTitle: 'device.devices'
            },
            ncyBreadcrumb: {
                label: '{"icon": "devices_other", "label": "device.devices"}'
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/hardware-entities/hardware-entities.routes.js